import { useMutation } from '@tanstack/react-query';
import api from '../../http';
import { toApiError } from '../utils';

interface ApiResponseHandoff {
	code: string;
}

export const useCreateHandoff = () => {
	return useMutation({
		mutationFn: async (rememberMe: boolean) => {
			try {
				const { data } = await api.post<ApiResponseHandoff>('/auth/handoff', { rememberMe });
				return data.code;
			} catch (error) {
				throw toApiError(error, 'Erro ao transferir sessão');
			}
		},
	});
};
